import { useNavigate } from "react-router";
import { useCallback, useEffect, useState } from "react";
import db, { Key } from "../../database/database";
import { getAPIClient } from "../../apiClient";
import { infoLog } from "../../utils/logger";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./navbar.css";
import React from "react";
import { STAY_LOGGED_IN_PW, hasScreeningsEnabled } from "../../globals";
import { useBranding } from "../../branding/useBranding";
import { getAuth } from "firebase/auth";
import { useAtom } from "jotai";
import logout from "../../utils/logout";
import { userAtom } from "../../jotai/atoms";
import { stopPolling } from "../../utils/polling";

export function Navbar() {
  const [stayLogged, setStayLogged] = useState<boolean | null>(null);
  const [user] = useAtom(userAtom);

  const branding = useBranding();

  const navigate = useNavigate();

  const { t } = useTranslation();
  const [menuIsActive, setMenuIsActive] = useState(false);

  const [navBarUserName, setNavBarUserName] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const navbarMenuRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const checkLoggedInStatus = async () => {
      try {
        await db().unlock(STAY_LOGGED_IN_PW);
        setStayLogged(true);
      } catch (e: unknown) {
        setStayLogged(false);
      }
    };

    checkLoggedInStatus();
  }, []);

  useEffect(() => {
    const closeMenu = (event: MouseEvent) => {
      if (
        menuIsActive &&
        navbarMenuRef.current &&
        !navbarMenuRef.current.contains(event.target as Node)
      ) {
        setMenuIsActive(false);
      }
    };

    document.body.addEventListener("mousedown", closeMenu);

    return () => {
      document.body.removeEventListener("mousedown", closeMenu);
    };
  }, [menuIsActive]);

  const handleClick = () => {
    setMenuIsActive(false);
  };

  async function signOut() {
    stopPolling();
    await logout(getAPIClient(), getAuth());
    navigate("/");
  }

  useEffect(() => {
    const userName = `${user?.first_name || ""} ${user?.last_name || ""}`;

    if (navBarUserName !== userName) {
      setEmail(user?.email ?? "");
      setNavBarUserName(userName);
    }
  }, [user]);

  return (
    <nav
      className="navbar docket-navbar"
      role="navigation"
      aria-label="main navigation"
      data-testid="navbar"
    >
      <div className="text-white w-36 cursor-pointer">
        <a className="" onClick={() => navigate("/home/search")}>
          <img src={`/${branding.headerImage}`} height="28" alt="Docket logo" />
        </a>
      </div>
      {stayLogged === false && (
        <div className="text-white">
          <p className="text-sm">
            <b>{t("generic.warning")}:</b> {t("menu.log_out_warning")}
          </p>
        </div>
      )}
      <div className="ml-auto">
        <ul className="menu menu-horizontal px-1">
          <li className="my-auto">
            <Link className="text-white" to="/home/search" onClick={handleClick}>
              {t("immunizations.tab_bar_search_title")}
            </Link>
          </li>
          <li className="my-auto">
            <Link className="text-white" to="/home/records" onClick={handleClick}>
              {t("menu.immunizations")}
            </Link>
          </li>
          {hasScreeningsEnabled(user?.email || "") && (
            <li className="my-auto">
              <Link className="text-white" to="/home/records/screening" onClick={handleClick}>
                {t("screening.tab_bar_screenings_title")}
              </Link>
            </li>
          )}
          <li className="my-auto">
            <Link className="text-white" to="/home/discover" onClick={handleClick}>
              {t("menu.discover")}
            </Link>
          </li>
          <li>
            <details>
              <summary className="navbar-summary">
                <div className="flex flex-col text-white">
                  <p>{`${navBarUserName}`}</p>
                  <div className="text-xs">{`${email}`}</div>
                </div>
              </summary>
              <ul className="p-2 w-full" style={{ backgroundColor: branding.headerColor }}>
                <li>
                  <Link to="/home/settings" className="text-white" onClick={handleClick}>
                    {t("menu.settings")}
                  </Link>
                </li>
                <li>
                  <a className="text-white my-auto" onClick={() => signOut().then(() => {})}>
                    {t("menu.sign_out")}
                  </a>
                </li>
              </ul>
            </details>
          </li>
        </ul>
      </div>
    </nav>
  );
}
